import React from 'react'

const Loader = () => {
    return (
        <div className="flex min-h-screen items-center justify-center">
            <div className="animate-spin rounded-full border-b-2 border-gray-900 h-5 w-5"></div>
        </div>
    )
}

export default Loader;


export const ListLoader = () => {
    return (
        <tr>
            <td colSpan={4} className="text-center py-8">
                <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
                    <span className="ml-2 text-gray-600">Loading...</span>
                </div>
            </td>
        </tr>
    )
}

export const DetailsLoader = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center">
            <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
                <p className="text-gray-600">Loading details...</p>
            </div>
        </div>
    )
}